module.exports = __webpack_public_path__ + "static/img/ContractIcon.dc87b15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ContractIcon.jpg
// module id = 8oRW
// module chunks = 1